import { useEffect } from "react";
import { useIANATimeZoneSetting } from "@/hooks/useSetting";
import { setBackofficeDisplayTimezone } from "@/utils/dateUtils";

/**
 * Applies the account `timezone` setting (IANA) for all backoffice date display helpers.
 * Must render under providers that supply React Query (settings fetch).
 */
export function BackofficeTimezoneSync(): null {
  const timezone = useIANATimeZoneSetting();

  useEffect(() => {
    setBackofficeDisplayTimezone(timezone);
  }, [timezone]);

  return null;
}
